import { apiFetch, type AjaxResult } from './http';

export interface QuotaSummary {
  pointsBalance: number;
  freeSearchRemaining: number;
  memberActive: boolean;
  memberExpireTime?: string;
  memberPermanent?: boolean;
  dailyCombinedLimit: number;
  dailyCombinedUsed: number;
  dailyCombinedRemaining: number;
  todayOrderUsed: number;
  todaySearchUsed: number;
  orderPointsCost: number;
  searchPointsCost: number;
}

export function fetchEntitlementQuota(): Promise<AjaxResult<QuotaSummary>> {
  return apiFetch<QuotaSummary>('/api/app/entitlement/quota', { method: 'GET', auth: true });
}
